var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('order-list-data-table',{attrs:{"title":"Delivered","defaultSortField":"delivered_at","defaultSortOrder":"dsc","headers":_vm.headers,"status":_vm.status,"assocs":_vm.assocs,"linkToLocations":true}})}
var staticRenderFns = []

export { render, staticRenderFns }